import React from 'react';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import { useDisableFocusTrapWithChatProps } from '@components/ChatAwareComponents/utilities/hooks/useDisableFocusTrapWithChatProps/useDisableFocusTrapWithChatProps';

export const ChatAwareDialog: React.FC<DialogProps> = ({ children, ...dialogProps }) => {
	const disableFocusTrapWithChatProps = useDisableFocusTrapWithChatProps();

	return (
		<Dialog
			{...disableFocusTrapWithChatProps}
			{...dialogProps}
		>
			{children}
		</Dialog>
	);
};
